module.exports = __webpack_public_path__ + "static/Customize-Colours-3-e1403553680845-b91f2bd8565f4606a21cd9646f009763.jpg";